module.exports = __webpack_public_path__ + "img/4.aaf8bed9.png";